<template>
    <section class="admin-content" id="contact-search">
        <Navbar />

        <main class="admin-main">
            <div class="bg-dark m-b-30">
                <div class="container">
                    <div class="row p-b-60 p-t-60">
                        <div class="col-md-6 text-center mx-auto text-white p-b-30">
                            <h3>{{ safePlans.length }} Plans</h3>
                            <strong>Plan Management</strong>
                        </div>
                    </div>
                </div>
            </div>

            <section class="pull-up">
                <div class="container">
                    <div class="row list">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div class="card-body">
                                    <button class="btn btn-info" @click="startAdd">
                                        {{ showForm ? "Hide Form" : "Add Plan" }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12" v-if="showForm">
                            <div class="card m-b-30">
                                <div class="card-header">
                                    <h3 class="h5 text-center m-0">
                                        {{ isEdit ? "Edit Plan" : "Add Plan" }}
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <div class="form-row">
                                      
                                        <div class="form-group col-md-6">
                                            <label>Title</label>
                                            <input type="text" class="form-control" v-model="form.title" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Cost</label>
                                            <input type="number" class="form-control" v-model="form.cost" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Plan Interval</label>
                                            <select class="form-control" v-model="form.plan_inteval">
                                                <option value="">Select Interval</option>
                                                <option>Yearly</option>
                                                <option>Monthly</option>
                                                <option>Weekly</option>
                                                <option>Daily</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Plan Category ID</label>
                                            <input type="text" class="form-control" v-model="form.plan_category_id" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>ID Card Code</label>
                                            <input type="text" class="form-control" v-model="form.id_card_code" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>ID Card Code With LGA</label>
                                            <input type="text" class="form-control" v-model="form.id_card_code_with_lga" />
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>Description</label>
                                            <textarea class="form-control" rows="4" v-model="form.description"></textarea>
                                        </div>
                                    </div>

                                    <button class="btn btn-primary mr-2" @click="submitPlan">
                                        {{ isEdit ? "Update Plan" : "Create Plan" }}
                                    </button>
                                    <button class="btn btn-outline-secondary" @click="cancelEdit">Cancel</button>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12" v-if="selectedPlan">
                            <div class="card m-b-30">
                                <div class="card-header">
                                    <h3 class="h5 m-0">Plan Details</h3>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3"><strong>Title:</strong> {{ selectedPlan.title }}</div>
                                        <div class="col-md-3"><strong>Cost:</strong> {{ selectedPlan.cost }}</div>
                                        <div class="col-md-3"><strong>Interval:</strong> {{ selectedPlan.plan_inteval }}</div>
                                        <div class="col-md-3"><strong>Category ID:</strong> {{ selectedPlan.plan_category_id }}</div>
                                        <div class="col-md-3"><strong>ID Card Code:</strong> {{ selectedPlan.id_card_code }}</div>
                                        <div class="col-md-3">
                                            <strong>ID Card Code With LGA:</strong> {{ selectedPlan.id_card_code_with_lga }}
                                        </div>
                                        <div class="col-md-12 mt-2"><strong>Description:</strong> {{ selectedPlan.description }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="table-responsive">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <table class="table align-td-middle table-card">
                                            <thead>
                                                <tr>
                                                    <th>SN</th>
                                                    <th>Title</th>
                                                    <th>Cost</th>
                                                    <th>Interval</th>
                                                    <th>Category</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(plan, index) in safePlans" :key="plan.id">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ plan.title }}</td>
                                                    <td> <i class="mdi mdi-currency-ngn"></i> {{ plan.cost }}</td>
                                                    <td>{{ plan.plan_inteval }}</td>
                                                    <td>{{ plan.category.name }}</td>
                                                    <td>
                                                        <button class="btn btn-default btn-sm m-1" @click="viewPlan(plan)">
                                                            <i class="fe fe-eye"></i>
                                                        </button>
                                                        <button class="btn btn-info btn-sm m-1" @click="startEdit(plan)">
                                                            <i class="fe fe-edit"></i>
                                                        </button>
                                                        <button class="btn btn-danger btn-sm m-1" @click="deletePlan(plan)">
                                                            <i class="fe fe-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="vld-parent">
                    <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
                </div>
            </section>
        </main>
    </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    components: {
        Navbar,
        Loading,
    },
    data() {
        return {
            user: null,
            isLoading: false,
            fullPage: true,
            showForm: false,
            isEdit: false,
            plans: [],
            selectedPlan: null,
            form: {
                id: "",
                title: "",
                description: "",
                cost: "",
                plan_inteval: "",
                plan_category_id: "",
                id_card_code: "",
                id_card_code_with_lga: "",
            },
        };
    },
    created() {
        this.getPlans();
    },
    computed: {
        safePlans() {
            if (!Array.isArray(this.plans)) {
                return [];
            }
            return this.plans.filter((plan) => plan && typeof plan === "object");
        },
    },
    methods: {
        notifySuccess(message) {
            if (this.$toasted) {
                this.$toasted.success(message, {
                    position: "top-right",
                    duration: 5000,
                });
                return;
            }
            if (this.$breadstick) {
                this.$breadstick.notify(message, { position: "top-right" });
            }
        },
        notifyError(message) {
            if (this.$toasted) {
                this.$toasted.error(message, {
                    position: "top-right",
                    duration: 5000,
                });
                return;
            }
            if (this.$breadstick) {
                this.$breadstick.notify(message, { position: "top-right" });
            }
        },
        getUser() {
            this.user = JSON.parse(localStorage.getItem("user"));
            return this.user;
        },
        getPayload() {
            return {
                agency_id: 407465,
                title: this.form.title,
                description: this.form.description,
                cost: this.form.cost,
                plan_inteval: this.form.plan_inteval,
                plan_category_id: this.form.plan_category_id,
                id_card_code: this.form.id_card_code,
                id_card_code_with_lga: this.form.id_card_code_with_lga,
            };
        },
        getPlans() {
           
            this.axios
                .get(`/api/v1/auth/plans`,{
                    params:{
                        agency_id: 407465
                    }
                })
                .then((response) => {
                    const rawPlans = response.data.data.data ;
                    this.plans = Array.isArray(rawPlans)
                        ? rawPlans.filter((plan) => plan && typeof plan === "object")
                        : [];
                })
                .catch((error) => {
                    console.error(error);
                    this.notifyError("Unable to fetch plans");
                });
        },
        startAdd() {
            this.showForm = !this.showForm;
            if (this.showForm) {
                this.isEdit = false;
                this.clearForm();
            }
        },
        viewPlan(plan) {
            if (!plan || !plan.id) {
                this.notifyError("Invalid plan record");
                return;
            }
            this.isLoading = true;
            this.axios
                .get(`/api/v1/auth/plans/${plan.id}`)
                .then((response) => {
                    this.selectedPlan = response.data.data || response.data;
                })
                .catch((error) => {
                    console.error(error);
                    this.notifyError("Unable to fetch plan details");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        startEdit(plan) {
            if (!plan || !plan.id) {
                this.notifyError("Invalid plan record");
                return;
            }
            this.isEdit = true;
            this.showForm = true;
            this.form.id = plan.id || "";
            this.form.title = plan.title || "";
            this.form.description = plan.description || "";
            this.form.cost = plan.cost || "";
            this.form.plan_inteval = plan.plan_inteval || "";
            this.form.plan_category_id = plan.plan_category_id || "";
            this.form.id_card_code = plan.id_card_code || "";
            this.form.id_card_code_with_lga = plan.id_card_code_with_lga || "";
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        cancelEdit() {
            this.isEdit = false;
            this.showForm = false;
            this.clearForm();
        },
        clearForm() {
            this.form.id = "";
            this.form.title = "";
            this.form.description = "";
            this.form.cost = "";
            this.form.plan_inteval = "";
            this.form.plan_category_id = "";
            this.form.id_card_code = "";
            this.form.id_card_code_with_lga = "";
        },
        submitPlan() {
            const user = this.getUser();
            if (!user || !user.id) {
                this.notifyError("User session not found");
                return;
            }

          
            this.isLoading = true;
            const payload = this.getPayload();

            if (!this.isEdit) {
                this.axios
                    .post("/api/v1/auth/plans", payload)
                    .then(() => {
                        this.clearForm();
                        this.getPlans();
                        this.notifySuccess("Plan added successfully");
                    })
                    .catch((error) => {
                        console.error(error);
                        this.notifyError("Unable to add plan");
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
                return;
            }

            this.axios
                .put(`/api/v1/auth/plans/${this.form.id}`, payload)
                .then(() => {
                    this.isEdit = false;
                    this.showForm = false;
                    this.clearForm();
                    this.getPlans();
                    this.notifySuccess("Plan updated successfully");
                })
                .catch((error) => {
                    console.error(error);
                    this.notifyError("Unable to update plan");
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async deletePlan(plan) {
            if (!plan || !plan.id) {
                this.notifyError("Invalid plan record");
                return;
            }
            if (!confirm("Are you sure you want to delete this plan?")) {
                return;
            }

            this.isLoading = true;
            try {
                await this.axios.delete(`/api/v1/auth/plans/${plan.id}`);
            } catch (error) {
                console.error(error);
                this.isLoading = false;
                this.notifyError("Unable to delete plan");
                return;
            }

            this.isLoading = false;

            if (this.selectedPlan && this.selectedPlan.id === plan.id) {
                this.selectedPlan = null;
            }
            this.getPlans();
            this.notifySuccess("Plan deleted successfully");
        },
    },
};
</script>
